import { Box, Typography, useMediaQuery } from '@mui/material'
import theme from 'lib/theme'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactJson from '@microlink/react-json-view'
import { useProductInfo } from './Product'

export const ProductRawData = () => {
  const { masterProduct } = useProductInfo()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useTranslation()
  const productInfoArr = [
    {
      title: 'GTIN',
      info: masterProduct.gtin,
    },
    {
      title: t('vendorId'),
      info: masterProduct.ext_id,
    },
    {
      title: t('masterProductId'),
      info: masterProduct.id,
    },
  ]

  // reactjsonview copy does not work with mui otherwise
  const handleCopy = (copy: {
    src: object
    namespace: Array<string | null>
    name: string | null
  }) => {
    navigator.clipboard.writeText(JSON.stringify(copy.src, null, 2))
  }

  return (
    <>
      <Box mt={3}>
        {productInfoArr.map((item) => (
          <Box mb={2} key={item.info}>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 'bold',
                color: theme.palette.text.secondary,
              }}>
              {item.title}
            </Typography>
            <Typography sx={{ fontSize: '18px' }}>{item.info}</Typography>
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          // calculate width based on sidebar, secondary sidebar, and remaining margin
          width: isMobile ? '90vw' : 'calc(100vw - 264px - 40px - 40px)',
          // calculate minHeight based on space taken up by previous box and margin
          minHeight: 'calc(100vh - 167px - 72px)',
          marginTop: theme.spacing(4),
          backgroundColor: theme.palette.neutral.grey12,
          padding: theme.spacing(2),
        }}>
        <ReactJson
          enableClipboard={handleCopy}
          src={masterProduct}
          theme='grayscale:inverted'
          style={{
            backgroundColor: theme.palette.neutral.grey12,
          }}
        />
      </Box>
    </>
  )
}
